// components/ModalFormFields.js
import React from 'react';

type ModalFormFieldsProps = {
    fields: Record<string, React.ReactNode>;
    error?: string;
};

export default function ModalFormFields({ fields, error }: ModalFormFieldsProps) {
    function isRequired(element) {
        // Check if the element or its props has required=true
        if (!element) return false;
        if (element.props && element.props.required) return true;
        // If it's a React.Fragment or array, check children
        if (Array.isArray(element)) {
            return element.some(isRequired);
        }
        if (element.type === React.Fragment && element.props && element.props.children) {
            return isRequired(element.props.children);
        }
        return false;
    }
    return (
        <>
            {Object.entries(fields).map(([label, element], i) => {
                const required = isRequired(element);
                return (
                    <div className="formGroup" key={label || i}>
                        <label>{label}{required && <span style={{ color: 'red' }}> *</span>}</label>
                        {element}
                    </div>
                );
            })}
            {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
        </>
    );
}